import styled from 'styled-components'
import { theme } from '../../../../../../style/theme'
import { colorTheme } from '../../../../../../style/theme/colorTheme'

export const PickupMonitorOptionButtonWrap = styled.button`
	font-size: 1rem;
	display: flex;
	height: 4.69em;
	padding: 0.13em 0.63em;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 0.31em;
	border-radius: 0.75em;
	border: 2px solid ${colorTheme.pickupMonitor.optionButton.border};
	background: ${colorTheme.pickupMonitor.optionButton.background};
	width: 100%;
	cursor: pointer;
	user-select: none;
	transition: all 0.2s ease-in-out;

	&:hover {
		box-shadow: 0px 4px 4px 0px ${colorTheme.pickupMonitor.optionButton.shadow};
	}

	&.awaiting-pickup {
		border-color: ${colorTheme.pickupMonitor.optionButton.awaitingPickup.border};
	}

	&.small {
		height: 3.13em;
		flex-direction: row;
		gap: 0.56em;
	}

	&.disabled {
		opacity: 0.8;
		border-color: ${colorTheme.pickupMonitor.optionButton.disabled};

		&:hover {
			box-shadow: none;
		}
	}
`
PickupMonitorOptionButtonWrap.displayName = 'PickupMonitorOptionButtonWrap'

export const PickupMonitorOptionButtonText = styled.div`
	color: ${colorTheme.pickupMonitor.optionButton.text};
	font-family: ${theme.fontRobotoMedium};
	font-size: 0.94em;
	font-weight: 500;

	&.small {
		font-size: 1em;
	}
`
PickupMonitorOptionButtonText.displayName = 'PickupMonitorOptionButtonText'

export const PickupMonitorOptionButtonIcon = styled.div`
	display: flex;
	align-items: center;

	> svg {
		width: 1.25em;
		height: 1.25em;
		flex-shrink: 0;
		fill: ${colorTheme.pickupMonitor.optionButton.icon};
	}

	&.awaiting-pickup {
		> svg {
			width: 1.56em;
			height: 1.13em;
			fill: ${colorTheme.pickupMonitor.optionButton.awaitingPickup.icon};
			transform: rotate(180deg);
		}
	}

	&.disabled {
		&.awaiting-pickup {
			> svg {
				fill: ${colorTheme.pickupMonitor.optionButton.disabled};
			}
		}
	}
`
PickupMonitorOptionButtonIcon.displayName = 'PickupMonitorOptionButtonIcon'
